// OAuthSuccessPage.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {useAuth} from "../AuthContext";
import { toast } from "../../../utils/toast";

const OAuthSuccessPage = () => {
    const navigate = useNavigate();
    const { login } = useAuth();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        const role = params.get("role");

        console.log("소셜 로그인 성공", token, role);

        if (token && role) {
            localStorage.setItem("token", token);
            // localStorage.setItem("userId", userId);
            login(token, "USER"); // authContext 상태 업데이트

            localStorage.setItem("role", role); // 소셜은 기본 USER
            navigate("/"); // 또는 /mypage
        } else {
            toast("소셜 로그인에 실패했습니다.");
            navigate("/login");
        }
    }, []);

    return null;
};

export default OAuthSuccessPage;
